
export const DEFAULT_VALUE = {
    title: "",
    backEnabled: true,
    helpEnabled: false,
    headerBackgroundColor: "#191919",
    onBackPressed: null,
    scannerEnabled: false,
    helpOptions: {
        open: false,
        title: "",
        pageTitle: "",
        list: []
    },
    backOptions: {
        open: false,
        primaryButtonTitle: "Continue Picking",
        primaryButtonOnClick: () => {
        },
        secondaryButtonTitle: "End Picking & Exit",
        secondaryButtonOnClick: () => {
        }
    },
    dialogOptions: {
        open: false,
        title: "",
        onClose: null,
        description: "",
        primaryButtonTitle: "",
        primaryButtonOnClick: null,
        secondaryButtonTitle: "",
        secondaryButtonOnClick: null
    },
    workflow: null,
    picklist: null
};

export const AppContextActions = {
    UPDATE_PICKLIST_DETAILS: "UPDATE_PICKLIST_DETAILS",
    UPDATE_WORKFLOW: "UPDATE_WORKFLOW",
    SETUP_HEADER: "SETUP_HEADER",
    SETUP_HELP: "SETUP_HELP",
    OPEN_HELP: "OPEN_HELP",
    CLOSE_HELP: "CLOSE_HELP",
    SET_HEADER_COLOR: "SET_HEADER_COLOR",
    OPEN_BACK_DROP: "OPEN_BACK_DROP",
    CLOSE_BACK_DROP: "CLOSE_BACK_DROP",
    SETUP_SCANNER: "SETUP_SCANNER",
    OPEN_DIALOG: "OPEN_DIALOG",
    CLOSE_DIALOG: "CLOSE_DIALOG"
}

export const AppContextReducer = (state, action) => {

    switch (action.type) {
        /**
         * Workflow, Picklist update
         */
        case AppContextActions.UPDATE_PICKLIST_DETAILS:
            return {...state, picklist: {...state.picklist, ...action.value}};
        case AppContextActions.UPDATE_WORKFLOW:
            return {...state, workflow: {...state.workflow, ...action.value}};

        /**
         * Header setup for back button and title, title doesn't change if not passed
         */
        case AppContextActions.SETUP_HEADER:
            return {...state, title: action.value.title || state.title, onBackPressed: action.value.onBackPressed};

        /**
         * SCANNER setup
         */
        case AppContextActions.SETUP_SCANNER:
            return {...state, scannerEnabled: action.value};

        /**
         * Help options
         */
        case AppContextActions.SETUP_HELP:
            return {...state, helpEnabled: action.value.enabled, helpOptions: {...action.value.options, open: false}};
        case AppContextActions.OPEN_HELP:
            return {...state, helpOptions: {...state.helpOptions, open: true}};
        case AppContextActions.CLOSE_HELP:
            return {...state, helpOptions: {...state.helpOptions, open: false}};

        /**
         * Header background
         */
        case AppContextActions.SET_HEADER_COLOR:
            return {...state, headerBackgroundColor: action.value};

        /**
         * Backdrop options
         */
        case AppContextActions.OPEN_BACK_DROP:
            return {...state, backOptions: {...state.backOptions, ...action.value, open: true}};
        case AppContextActions.CLOSE_BACK_DROP:
            return {...state, backOptions: {...state.backOptions, open: false}};

        /**
         * Dialog options
         */
        case AppContextActions.OPEN_DIALOG:
            return {...state, dialogOptions: {...state.dialogOptions, ...action.value, open: true}};
        case AppContextActions.CLOSE_DIALOG:
            return {...state, dialogOptions: {...state.dialogOptions, open: false}};

        /**
         * returning the same state
         */
        default:
            return state;
    }
}